import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    interactiveState,
    isSelected
  } = _ref;
  var height = designContext.get('menu-tab/height').value();
  var horizontalPadding = designContext.get('menu-tab/horizontal-padding').value();
  var borderWidth = isSelected ? 2 : 0;
  return {
    keyboardFocusStyle: {
      position: 'absolute',
      top: -6,
      left: -6,
      right: -6,
      bottom: -6,
      borderRadius: designContext.get('menu-tab/keyboard-focus-corner-radius').pixelValue,
      borderWidth: 2,
      borderColor: designContext.get('menu-tab/keyboard-focus-border-color').toString(),
      borderStyle: 'solid'
    },
    radioStyle: {
      height,
      margin: 0,
      opacity: 0,
      position: 'absolute',
      width: '100%',
      zIndex: 1,
      cursor: 'pointer',
      // this is purely to remove any highlight and therefore should not form part of the themeable component tokens
      WebkitTapHighlightColor: designContext.get('colors/backgrounds/transparent').toString()
    },
    rootStyle: {
      alignItems: 'center',
      borderColor: designContext.get('menu-tab/underline-color', {
        interactiveState
      }).toString(),
      borderBottomWidth: borderWidth,
      boxSizing: 'border-box',
      cursor: 'pointer',
      height,
      justifyContent: 'center',
      paddingLeft: horizontalPadding,
      paddingRight: horizontalPadding,
      paddingTop: borderWidth,
      position: 'relative'
    },
    textStyle: _objectSpread(_objectSpread({}, designContext.get('menu-tab/text-style').styles()), {}, {
      color: designContext.get('menu-tab/text-color', {
        interactiveState,
        isSelected: isSelected ? 'selected' : 'default'
      }).toString(),
      textAlign: 'center',
      userSelect: 'none'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map